import React from 'react';
import { ComponentComponentsFormSection } from '../../../types/schema';
import { PromptQuestions } from '../types';

export const useVisibleQuestionTitles = (
  filteredSections: (ComponentComponentsFormSection | null | undefined)[],
  promptQuestions: PromptQuestions,
) => {
  return React.useMemo(() => {
    const titles = new Set<string>();

    filteredSections.forEach((section) => {
      section?.questions?.forEach((q) => {
        if (q?.title) titles.add(q.title);
      });

      const sectionPromptQuestions = promptQuestions[section?.id || ''] || [];
      sectionPromptQuestions.forEach((q) => {
        if (q?.title) titles.add(q.title);
      });
    });

    return titles;
  }, [filteredSections, promptQuestions]);
};
